import { Navbar } from "react-bootstrap";

const NavBar = () => {
  return (
    <Navbar className="justify-content-between fixed-top navbar">
      <Navbar.Brand href="/" className="navbar__logo" />
      <h1 className="navbar__title">
        TRÁMITE SIMPLIFICADO DE TRANSPORTES ESCOLARES
      </h1>
    </Navbar>
  );
};

export default NavBar;
